import Env from 'enviro';
import { getFullUrl } from 'hubspot-url-utils';
import { ENGAGEMENT_LOCATION } from '../constants/comments';
import { routes } from '../constants/routes';
import { pluralTypeToId, pluralTypeToSingle, typeToId } from '../constants/types';
export const getBaseUrl = () => `/${window.location.pathname.split('/')[1]}` || routes.base;
export const generateObjectDirectLink = (portalId, type, objectId) => `${getFullUrl('app')}/contacts/${portalId}/${pluralTypeToSingle[type]}/${objectId}`;
export const buildOpenPlaybookUrl = ({
  portalId,
  playbookId,
  selectedObjectType,
  selectedObjectId,
  callObjectId,
  engagementLocation = ENGAGEMENT_LOCATION
}) => `${getFullUrl('app')}/playbooks-modal/${portalId}/playbook/${playbookId}/${pluralTypeToId[selectedObjectType]}/${selectedObjectId}?insertNotesToEngagementId=${callObjectId}&insertNotesToEngagementLocation=${engagementLocation}`;
export const generateConnectCalendarDirectLink = portalId => `${getFullUrl('app')}/settings/${portalId}/user-preferences/calendar`;
export const generateCallsDirectLink = (portalId, filters) => `${getFullUrl('app')}/contacts/${portalId}/objects/${typeToId.callObject}/views/all/list${filters ? `?filters=${encodeURIComponent(filters)}` : ''}`;
export const getDraftMeetingPlannerUrl = ({
  callObjectId,
  portalId,
  outsideMeetingRoute,
  draftRoute,
  contactsRoute
}) => `/${portalId}${outsideMeetingRoute}${draftRoute}/${callObjectId}${contactsRoute}`;
export const generateCallObjectDirectLink = (callObjectId, portalId) => `${getFullUrl('app')}/calls/${portalId}/review/${callObjectId}`;
export const getAppDomain = hublet => {
  return getFullUrl(Env.deployed() ? 'app' : 'local', {
    hubletOverride: hublet
  });
};
export const getBaseUrlWithCorrectHublet = hublet => `${getAppDomain(hublet)}${getBaseUrl()}`;
export const generateMarketplaceLink = ({
  portalId,
  slug
}) => {
  return `${getFullUrl('app')}/ecosystem/${portalId}/marketplace/apps/sales/sales-enablement/${slug}`;
};
export const generateManageProductsLink = portalId => `${getFullUrl('app')}/contacts/${portalId}/objects/${typeToId.product}/views/all/list`;